export const checkResponseStatus = (status: number) => {
  if (status === 401 || status === 403) {
    localStorage.clear();
    window.location.reload();
  }
};
